<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    // 检查本地存储
    const logs = localStorage.getItem('logs') || '[]'
    const logsArray = JSON.parse(logs)
    logsArray.unshift(Date.now())
    localStorage.setItem('logs', JSON.stringify(logsArray))

    // 用户登录逻辑
    this.handleLogin()
  },
  methods: {
    handleLogin() {
      // 这里实现 Web 版本的登录逻辑
      // 可以使用普通的账号密码登录，或者其他第三方登录
      console.log('Implement web login logic here')
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f5f5;
}


#app {
  min-height: 100vh;
  padding: 20px;
}
</style> 